import styled from 'styled-components';
import CheckBoxUncheckedSvg from './../assets/checkbox-unchecked.svg';

const CheckBoxUncheckedIcon = styled(
  CheckBoxUncheckedSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  margin-right: ${props => props.theme.spacing.base};
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.color};
  cursor: pointer;
`;

export default CheckBoxUncheckedIcon;
